<template>
  <div class="ticket-page" style="position: relative">
    <TicketInfo :match="nextMatch" @modalOpen="infoOpenModal"/>
    <div class="container">
      <!--
      <div class="policy-guide" @click="showModal = true">
        <div>
          <p class="title">티켓정책안내</p>
          <p><span>전남드래곤즈에서</span> 티켓정책 안내드립니다</p>
        </div>
        <img src="@/assets/img/icon/icon_policy_guide.png" alt="">
      </div>
      -->

      <TicketResults v-if="seasonType.reservations" v-bind:list="nextMatchList" />
      <div v-else style="padding: 35px 0;">
        <img src="@/assets/img/ticket/jd_ticket_policy.png" alt="">
        <!--<PageComingSoon :titleText="' '" :descriptionText="String(seasonMsg)" />-->
      </div>

      <div v-if="showModal" class="modal-wrapper">
        <div class="modal">
          <div class="modal-content">
            <div class="hidden">
              <button class="close-icon" @click="showModal = false">
                <img src="@/assets/img/icon/icon_modal_close.png" alt="">
              </button>
            </div>
            <div class="img-div">
              <swiper ref="ticketSwiper" :options="swiperOption" class="mySwiper">
                <swiper-slide
                    v-for="(item, index) in list"
                    :key="index"
                    class="slide">
                  <img :src="imageSrc(item.img)" alt=""/>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
            <button class="close" @click="showModal = false">닫기</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TicketInfo from '@/components/Ticket/TicketInfo.vue';
import TicketResults from '@/components/Ticket/TicketResults.vue';
import dayjs from "dayjs";
import {leagueName, leagueNameText, oldLeagueName} from "@/lib/match";
import {checkBrowser} from '@/lib';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import PageComingSoon from '@/components/Common/PageComingSoon';

export default {
  name: 'TicketReservations',
  components: {
    TicketResults,
    TicketInfo,
    Swiper,
    SwiperSlide,
    // PageComingSoon
  },
  data() {
    return {
      showModal: false,
      modalTop: 0,
      modalHeight: 0,
      currentYear: '',
      nextMatch: {},
      nextMatchList: [],
      confirmation: {}, // 예매 확인
      confirmationUrl: '',
      ticketing: {}, // 예매
      ticketingUrl: '',
      list: [
        {img: 'policy_guide_2026.png'},
        {img: 'ticketguide1.png'},
        {img: 'ticketguide2.png'},
        {img: 'ticketguide3.png'}
      ],
      loop: false,
      swiperOption: {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoHeight: true
      },
      swiperPause: false,
      seasonType: this.$store.getters['getSeasonType'],
      seasonMsg: this.$store.getters['getSeasonMsg'],
    }
  },
  created() {
    this.currentYear = dayjs().format('YYYY');
  },
  watch: {
    list(newList) {
      this.swiperOptions.loop = newList.length > 1;
    }
  },
  mounted () {
    this.getMatch();

    const swiper = this.$refs.ticketSwiper;
    if (swiper) {
      swiper.$swiper.activeIndex = 1;
    }
  },
  methods: {
    async getMatch() {
      const {data} = await this.$http.get(`/game/next?page=1&limit=3`)

      if(data.success) {
        data.data.map(item => {
          const meet_year = dayjs(item.game_date).format('YYYY');
          if(meet_year >= 2013) {
            item.league_name = leagueName(item.meet_name);
          } else {
            item.league_name = oldLeagueName(item.meet_seq, item.meet_name);
          }
          item.league_name_txt = leagueNameText(item.league_name);

          item.game_date = dayjs(item.game_date).format('YYYY.MM.DD');
          item.game_time = item.game_time.substring(0, 5);
        })

        this.nextMatch = data.data[0];
        this.nextMatchList = data.data.slice(1,3);
      }
    },
    infoOpenModal(data) {
      this.showModal = data;
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/ticket/'+imgSrc);
    }
  }
}
</script>
<style scoped>

</style>
